import { useCallback } from 'react';
import { RootState } from '../store';
import * as MateriaActions from '../store/Materias.reducer';
import { useAppDispatch, useAppSelector } from './hooks';

export default function useMaterias() {
  const dispatch = useAppDispatch();

  const materias = useAppSelector((state: RootState) => state.materias.list);

  const materia = useAppSelector((state: RootState) => state.materias.materia);

  const fetching = useAppSelector((state: RootState) => state.materias.fetching);

  const fetchMaterias = useCallback(() => {
    dispatch(MateriaActions.getTodasAsMaterias());
  }, [dispatch]);

  const getMateria = useCallback(
    (objeto:any) => {
      dispatch(MateriaActions.getMateria(objeto));
    },
    [dispatch]
  );

  return {
    fetchMaterias,
    getMateria,
    materia,
    materias,
    fetching,
  };
}
